module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "single-file-upload-box"
  }, [(!_vm.isAvailable) ? _c('span', [_vm._v(_vm._s(_vm.file.name))]) : _vm._e(), _vm._v(" "), (!_vm.isAvailable) ? _c('el-button', {
    staticClass: "file-exists",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.onDelete(_vm.file)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e(), _vm._v(" "), (_vm.isAvailable) ? _c('vue-base64-file-upload', {
    attrs: {
      "input-class": "uploader",
      "accept": _vm.acceptedTypes,
      "disable-preview": true,
      "placeholder": "Clique aqui para selecionar um arquivo",
      "max-size": _vm.maxFileSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "file": _vm.onFile,
      "load": _vm.onLoad
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-611cf0fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/form/SingleUpload.vue
// module id = 757
// module chunks = 2